import { AutogenModelDriverSendMessage, AutogenRowDriverSendMessage } from "./autogen/AutogenModelDriverSendMessage";

export class ModelDriverSendMessage extends AutogenModelDriverSendMessage<RowDriverSendMessage> {
	constructor() {
		super(RowDriverSendMessage);
	}
}

export class RowDriverSendMessage extends AutogenRowDriverSendMessage {
}